import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'SelectMemberPushMessageList',
  data: function data() {
    return {
      isOptionUser: this.checkauthority('user_option'),
      isNewUser: this.checkauthority('new_user_message'),
      isBothdy: this.checkauthority('bothdy_message'),
      isPushMessage: this.checkauthority('push_list_message'),
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isSelect: this.checkauthority('message_select'),
      isDelete: this.checkauthority('message_del'),
      isCread: this.checkauthority('message_add'),
      selectForm: {},
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      pushMessagePushTypeEnums: [],
      pushMessagePerporGroup: [],
      menuList: [],
      type: 0,
      title: ''
    };
  },
  methods: {
    setTitle: function setTitle(title) {
      this.title = title;
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    },
    messageTypeBtn: function messageTypeBtn(type) {
      this.pageNo = 1;
      this.type = type;
      this.initTableData();
    },
    openPushUser: function openPushUser() {
      this.pushUserEditDisabled = false;
      this.pushUserDialogVisible = true;
      this.$refs.pushUser.setTitle('设置消息账号');
      this.$refs.pushUser.initData(0);
    },
    pushUserClose: function pushUserClose() {
      this.pushUserDialogVisible = false;
    },
    changePeporGroup: function changePeporGroup(row) {
      for (var index in this.pushMessagePerporGroup) {
        var item = this.pushMessagePerporGroup[index];
        if (item.values === row.peopleGroup) {
          return item.keys;
        }
      }
      return '';
    },
    changeMessagePushType: function changeMessagePushType(row) {
      try {
        for (var index in this.pushMessagePushTypeEnums) {
          var item = this.pushMessagePushTypeEnums[index];
          if (item.values === row.pushMessage.pushType) {
            return item.keys;
          }
        }
        return '';
      } catch (e) {
        return '';
      }
    },
    getImagesImage: function getImagesImage(row) {
      try {
        var url = JSON.parse(row.pushMessage.images)[0].url;
        return this.downloadUrl + url;
      } catch (e) {
        return '';
      }
    },
    getImagesImages: function getImagesImages(row) {
      var _this = this;
      try {
        var images = JSON.parse(row.pushMessage.images);
        var urls = [];
        images.forEach(function (img) {
          urls.push(_this.downloadUrl + img.url);
        });
        return urls;
      } catch (e) {
        return [];
      }
    },
    pushMessagePerporGroupEnums: function pushMessagePerporGroupEnums() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: 'push_message_people_group'
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this2.pushMessagePerporGroup = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getPushMessagePushTypeEnums: function getPushMessagePushTypeEnums() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: 'push_message_type'
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this3.pushMessagePushTypeEnums = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this4 = this;
      this.$confirm('确定删除该条信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.daleteApi(index, data);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                messageId: data.messageId
              };
              _context3.n = 1;
              return api.DELETE_PUSHMESSAGE(par);
            case 1:
              _this5.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.DELETE_BATCH_PUSHMESSAGE(par);
            case 1:
              _this6.$message.success('操作成功');
              _this6.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this7 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this7.tableSelects.forEach(function (element) {
          par.push(element.messageId);
        });
        _this7.deleteBatchApi(par);
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData(this.type);
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData(member) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                pageNo: _this8.pageNo,
                pageSize: _this8.pageSize,
                memberId: member.memberId
              };
              _context5.n = 1;
              return api.GET_BYPUSHMESSAGEMEMBER_PAGE_LIST(par);
            case 1:
              res = _context5.v;
              _this8.tableData = res.body.datas;
              _this8.pageTotal = res.body.sumDataCount;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.getPushMessagePushTypeEnums();
    this.pushMessagePerporGroupEnums();
  }
};